<script setup lang="ts">
import { ref } from "vue";
import { Permission } from "../../../../../types/auth";
import { CashierDuty } from "../../../../../types/models";
import { FilterField, TableAction, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";
import ModalFormTemplate from '../../../../../components/ui/Templates/ModalFormTemplate.vue'

defineProps<{
  cashierDuty: CashierDuty | null
}>();

const endPoint = "/clients/finance/collections/shift-end-reports/";
const title = "Shift End Reports";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);
const permissions = ref<Permission[]>();

const fields: TableField[] = [
  { name: 'date_time', caption: 'Date', sortable: true, fieldType: 'text' },
  { name: 'outlet', caption: 'Outlet', sortable: true, fieldType: 'text' },
  { name: 'outlet_pos_station', caption: 'POS Station', sortable: true, fieldType: 'text' },
  { name: 'user', caption: 'Cashier', sortable: true, fieldType: 'text' },
  { name: 'system', caption: 'System', sortable: true, fieldType: 'number', width: '150px' },
  { name: 'counted', caption: 'Actual', sortable: true, fieldType: 'number', width: '150px' },
  { name: 'difference', caption: 'Difference', sortable: true, fieldType: 'number', width: '150px' },
  { name: 'status', caption: 'Status', sortable: false, fieldType: 'text' },
]

const actions: TableAction[] = [];


const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  console.log('changeMode', mode)
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};

const handleLists = (_list: any) => {};

const handleTableActions = (_action: any, _data: any)  => {}

const handlePermissions = (perm: Permission[]) => {
  permissions.value = perm;
};

const listViewRef = ref<InstanceType<typeof ListTemplate> | null>(null);
/*const viewDocument = (data : any, title: string, path: string) => {
  if (listViewRef.value) {
    listViewRef.value.viewDocument(data, title, path);
  }
}*/

</script>

<template>
    <ModalFormTemplate
    mode="view" title="Sales Invoices" :endPoint="endPoint" :fullscreen="true"
    :ignore-permission="true"
    :tabList="[]" 
    @close="$emit('close')"
    >
    <template #form>
  <ListTemplate
   ref="listViewRef"
    :endPoint="endPoint"
    :title="title"
    :fields="fields"
    :actions="actions"
    :show-header="false"
    :filterFields="filterFields"
    @permissions="handlePermissions"
    :params="[
        {field: 'users_id', value: cashierDuty?.users_id, required: true},
    ]"
    :tabList="[]"
    :refreshData="refreshData"
    @custom="handleTableActions"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @lists="handleLists"
    :allow-disable="false"
    :show-quick-view="true"
    :show-share-actions="true"
    :allow-edit="false"
    @data="handleData"
  >
  </ListTemplate>
  </template>
  </ModalFormTemplate>


</template>
